'use client';

export default function RootError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main>
      <h1>Не удалось загрузить страницу</h1>
      <p>Сервис временно недоступен.</p>
      <button type="button" onClick={reset}>
        Повторить
      </button>
    </main>
  );
}
